import { render, staticRenderFns } from "./RaffleCard.vue?vue&type=template&id=bcdb7c9e&scoped=true"
import script from "./RaffleCard.vue?vue&type=script&lang=js"
export * from "./RaffleCard.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=bcdb7c9e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcdb7c9e",
  null
  
)

export default component.exports